var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOrganizacion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_806_419)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.8417 18.522C27.8417 16.6391 26.1554 15.1071 24.0826 15.1071H23.7237V13.0434C23.7237 9.32171 21.3809 6.13751 18.0928 4.8866V3.09278C18.0928 1.38742 16.7054 0 15.0001 0C13.2947 0 11.9073 1.38742 11.9073 3.09278V4.8866C8.61921 6.13751 6.27636 9.32171 6.27636 13.0434V15.1071H5.91748C3.84469 15.1071 2.15845 16.6391 2.15845 18.522V27.1083H6.27636V30H23.7237V27.1083H27.8417V18.522ZM24.0826 16.9628C25.1322 16.9628 25.986 17.6623 25.986 18.522V18.8313H23.7237V16.9628H24.0826ZM13.7629 3.09278C13.7629 2.41064 14.3179 1.85567 15.0001 1.85567C15.6822 1.85567 16.2372 2.41064 16.2372 3.09278V4.40777C15.8329 4.35012 15.42 4.31963 15.0001 4.31963C14.5801 4.31963 14.1672 4.35012 13.7629 4.40777V3.09278ZM15.0001 6.1753C18.4724 6.1753 21.3508 8.76569 21.8052 12.1155H18.7753V10.5691H16.9196V12.1155H13.0805V10.5691H11.2248V12.1155H8.19494C8.64933 8.76575 11.5277 6.1753 15.0001 6.1753ZM5.91748 16.9628H6.27636V18.8313H4.01412V18.522C4.01412 17.6623 4.86791 16.9628 5.91748 16.9628ZM4.01412 25.2526V20.6869H6.27636V25.2526H4.01412ZM8.13204 28.1443V13.9712H11.2248V20.9962H13.0805V13.9712H16.9196V20.9962H18.7753V13.9712H21.8681V28.1443H8.13204ZM23.7237 25.2526V20.6869H25.986V25.2526H23.7237Z",
    fill: "#359C4F",
    stroke: "white",
    strokeWidth: 0.412371
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_806_419"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrganizacion);
export default __webpack_public_path__ + "static/media/organizacion.410310f3d2a4e30418460cd2fe99d19d.svg";
export { ForwardRef as ReactComponent };